exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.btn--delete[data-v-4a70de9e] {\n    padding: 2px 5px 3px;\n}\n", "", {"version":3,"sources":["/Users/marco/vitamin2/solarapp-frontend-management/src/components/atoms/button/src/components/atoms/button/DeleteBtn.vue"],"names":[],"mappings":";AAiBA;IACA,qBAAA;CACA","file":"DeleteBtn.vue","sourcesContent":["<template>\n    <el-button\n        class=\"btn btn--delete\"\n        circle type=\"danger\"\n        size=\"mini\"\n        @click=\"$emit('clicked')\">\n        x\n    </el-button>\n</template>\n\n<script>\n    export default {\n        name: 'DeleteBtn',\n    };\n</script>\n\n<style scoped>\n    .btn--delete {\n        padding: 2px 5px 3px;\n    }\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a70de9e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/atoms/button/DeleteBtn.vue
// module id = I7my
// module chunks = 1